export default __webpack_public_path__ + "static/media/152.b977a374.svg";